import styled from 'styled-components';

export const AccessibilityWrapper = styled.div`
  padding: 6rem 2rem;
  background: ${props => props.theme.colors.background};
`;

export const AccessibilityContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  color: ${props => props.theme.colors.darkGreen};
  font-size: ${props => props.theme.fontSizes.huge};
  margin-bottom: 2rem;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.fontSizes.large};
  text-align: center;
  margin-bottom: 4rem;
`;

export const Section = styled.section`
  margin-bottom: 3rem;

  h2 {
    color: ${props => props.theme.colors.brown};
    font-size: ${props => props.theme.fontSizes.xlarge};
    margin-bottom: 1rem;
  }

  p {
    line-height: 1.8;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;

export const ListItem = styled.li`
  padding: 0.5rem 0;
  padding-right: 1.5rem;
  position: relative;

  &:before {
    content: '✓';
    position: absolute;
    right: 0;
    color: ${props => props.theme.colors.brown};
  }
`; 